import { Container } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const Order = {
  Container: styled(Container)`
    display: grid;
    gap: ${theme.space[1]};
  `,
};
